<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-db-selector"
      dialog-max-width="calc(100vw - 2rem)"
      dialog-max-height="80vh"
    >
      <template #header>
        <BaseIcon size="size-6" name="mdi/cloud-download" />
        {{
          ls({
            ja: 'アップロードした画像から選ぶ',
            en: 'Select from Uploaded',
          })
        }}
      </template>
      <div class="jps-modal-content" v-if="ss.searched">
        <div class="search-control">
          <SearchBoxSimple :ss="ss" />
        </div>
        <div class="content-list">
          <SearchCount :ss="ss" />
          <ContentPanel
            v-for="content in ss.state.result.list"
            :key="content.id"
            :content="content"
            :selectable="true"
            @select="select"
          />
          <SearchInfiniteLoading :ss="ss" />
        </div>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { type Image, dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls } = useI18n()
const { searchContent } = useContent()

interface Props {
}
const props = withDefaults(defineProps<Props>(), {
})

const modal = ref<InstanceType<typeof BaseModal>>()
const ss: Ref<SearchStore<Content>> = ref(null)
const openAwait = async () => {
  ss.value = useSearch<Content>(
    { keywordFields: ['keywords'] },
    searchContent,
    {
      configSyncRoute: false,
      configNoCache: true,
      configFreeze: false,
      queryRewriter: (q: SearchQuery) => {
        q.permission = 'O'
        q.sort = ['edit.date:desc']
        return q
      }
    }
  )
  ss.value.execute()
  return await modal.value.openAwait<{ content: Content, image: Image }>()
}
defineExpose({ openAwait })

const select = (c) => {
  modal.value.resolve(c)
}
</script>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

.jps-db-selector {
  .db-media {
    cursor: pointer;
    &:not(:first-child) {
      padding-top: 0.5em;
    }
    &.selected {
      .media {
        background: $jps-key-blue;
        h3,
        p {
          color: $white;
        }
      }
    }
  }
  .media {
    @include box-shadow;
    &:hover {
      border: 1px solid $jps-gray-300;
      background: $jps-gray-100;
    }
    background: $white;
    padding: 0.5rem;
    border: 1px solid $white;
    h3 {
      margin-top: 0.5rem;
    }
    p {
      line-height: 125%;
    }
  }

  .view-mode {
    margin-top: 1em;
    margin-bottom: 1em;
  }

  .search-parts {
    display: flex;
    margin-bottom: 1em;
    @include is-mobile() {
      flex-direction: column;
    }
    .search-paginaition {
      flex-grow: 1;
    }
    .size-sort {
      display: flex;
    }
  }

  .result {
    margin-top: 1em;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .search-result-table {
    overflow-x: scroll;
  }
}
</style>
